/*! wmf.js (C) 2020-present SheetJS LLC -- https://sheetjs.com */
var WMF = require("../js/");
module.exports = WMF;
